import { DataTableColumn } from '../DataTable.types';

/**
 * The columns DataTableFilterDrawer will actually render a filter card for.
 *
 * A column is filterable only with BOTH `filterConfig.enabled` and a `filterConfig.filterType`
 * — a config missing either produces no card. This is the single definition of "filterable":
 * the drawer derives its cards from it, and callers gate their filter button on it, so the
 * button can never open a drawer with nothing in it.
 */
export function getFilterableColumns(columns: DataTableColumn[] | undefined | null): DataTableColumn[] {
    return (columns ?? []).filter((column) => column.filterConfig?.enabled && column.filterConfig?.filterType);
}

/**
 * Whether a column set has anything to filter on — the condition for showing a filter button.
 *
 * Columns are config-driven (polus ViewConfig), so a table whose config seeds no filterable
 * column, or whose config hasn't loaded yet, must not offer the control at all.
 */
export function hasFilterableColumns(columns: DataTableColumn[] | undefined | null): boolean {
    return getFilterableColumns(columns).length > 0;
}

/**
 * The columns a table will actually render, per the ViewConfig `show` flag.
 *
 * Mirrors DataTable's own gate (DataTable.tsx:161-169) so a consumer that mounts
 * DataTableFilterDrawer without a DataTable — the mobile Manage Lenders/Partners drawer —
 * offers exactly the filter cards the desktop table's drawer does. `show: undefined` means
 * visible; only an explicit non-true value hides a column.
 */
export function getVisibleColumns(columns: DataTableColumn[] | undefined | null): DataTableColumn[] {
    return (columns ?? []).filter((column) => column.show === undefined || column.show === true);
}
